import { useTranslation } from 'react-i18next';

import type { BizyUiBlock } from '@bonusly/bizy-kit';
import { Box, Text } from '@bonusly/design-system';

/**
 * Fallback renderer for any block whose `type` this client doesn't
 * know about. Shows a minimal placeholder instead of crashing the
 * message, so an older Kaleidoscope build can still participate in a
 * conversation that used a block type shipped after it.
 */
export function UnknownBlockView({ block }: { block: BizyUiBlock }) {
	const { t } = useTranslation('admin_bizy');
	return (
		<Box my={2} px={3} py={2} bg="bg.subtle" border="1px dashed" borderColor="border.default" borderRadius="md">
			<Text fontSize="xs" color="text.softer">
				{t('uiBlocks.unknown', { type: block.type })}
			</Text>
		</Box>
	);
}
